
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../../controlador';
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
    import { Wait, WaitEntre } from '@/__env/ext';
    import { Utiles } from '@/__env/pluggins/event-bus';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        @Prop() public Pregunta: Pregunta;
        @Watch( 'Pregunta' )
        onPregunta()
        {
            this.Respuesta = '';
        }

        public Cargando: boolean = false;
        public Focused: boolean = false;
        public Respuesta: string = '';

        async Enviar()
        {
            if ( !this.Respuesta )
                return;

            this.Cargando = true;
            await Wait( 100 );
            let e = await this.Pregunta.Responder( this.Respuesta );
            if ( e )
            {
                if ( e == "ya-respondida" )
                {
                    Utiles.Notificaciones.Error( 'Pregunta respondida por otro usuario' );
                }
                this.$emit( 'aplicado', true );
                this.Cargando = false;
                this.Cerrar();
            } else
            {
                await Wait( 100 );
                this.Cargando = false;
                Utiles.Notificaciones.Error( 'Error al responder' );
            }
        }

        Cerrar()
        {
            this.$emit( 'cerrar' );
        }

    }
